import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

export default function PrivateRoute({ children, allow, adminPermission }) {
  const { token, role, me, loading } = useAuth();
  if (loading) {
    return (
      <div className="resqly-shell">
        <div className="resqly-frame flex items-center justify-center min-h-screen">
          <div className="text-slate-500 text-sm">Loading...</div>
        </div>
      </div>
    );
  }
  if (!token) {
    if (allow && allow.includes('admin')) return <Navigate to="/admin" replace />;
    if (allow && allow.includes('provider')) return <Navigate to="/provider/login" replace />;
    return <Navigate to="/consumer/login" replace />;
  }
  if (role === 'admin' && adminPermission && me && !me.is_owner && !(me.permissions || []).includes(adminPermission)) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  if (role === 'admin' && me?.must_change_password && !window.location.pathname.startsWith('/admin/security')) {
    return <Navigate to="/admin/security" replace />;
  }
  if (allow && !allow.includes(role)) {
    if (role === 'provider') return <Navigate to="/provider/dashboard" replace />;
    if (role === 'consumer') return <Navigate to="/consumer/home" replace />;
    if (role === 'admin') return <Navigate to="/admin" replace />;
  }
  return children;
}
